module.exports = __webpack_public_path__ + "media/images/icons/star-1-red-1208e5a8983f27d33728e8a93dc3a92d.svg";